import React, { useEffect, useState } from 'react'
import DataTable from '../../../component/data_table/DataTable'
import AddButton from '../../../component/buttons/AddButton';
import { Link, useNavigate } from 'react-router-dom';
import { FilePenLine, LockKeyhole, Trash2 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { gateListTodo } from '../../../redux/slices/master/gate/GateList';
import Loader from '../../../component/loader/Loader';
import { deleteGateTodo } from '../../../redux/slices/master/gate/DeleteGate';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip';
import UpdatePsw from '../../login/UpdatePsw';
import UpdateGatePass from '../../login/UpdateGatePass';

export default function GateList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false)
    const [userData, setUserData] = useState('')
    const gateList = useSelector(state => state?.gateList?.data?.data)



    const list_res = (res) => {
        if (res?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const editItem = (data) => {
        navigate('/update-gate', { state: data })
    }

    const passwordUpdate = (data) => {
        setShow(true)
        setUserData(data)
    }

    const deleteItem = (data) => {
        Swal.fire({
            title: "Gate Delete",
            text: 'Are you sure want to delete',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Confirm'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteGateTodo(data)).then((res) => del_res(res))
            }
        })
    }

    const del_res = (res) => {
        if (res?.payload?.status == 204) {
            setLoading(false)
            setBool(!bool)
            Swal.fire({
                title: 'Gate',
                text: res?.data?.massage,
                icon: 'success',
                confirmButtonText: 'OK'
            })

        } else if (res?.payload?.status == 401) {
            setLoading(false)
            localStorage.clear();
            navigate('/login')
        } else if (res?.payload?.status == 400) {
            setLoading(false)
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        } else if (res?.payload?.status == 404) {
            setLoading(false)
            toast.error('Not Found', { position: "bottom-right" });
        } else {
            setLoading(false)
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }

    const getImageUrl = (fileName) => {
        if (!fileName) return '';
        const base = process.env.REACT_APP_IMAGE_URL;
        return `${base}/${fileName}`;
    }

    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            filter: false,
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'IMAGE',
            field: 'gate_image',
            cellRenderer: (params) =>
                params?.value ? (
                    <img
                        src={getImageUrl(params.value)}
                        alt={params?.data?.name || 'gate'}
                        style={{ height: 40, width: 40, objectFit: 'cover', borderRadius: 4 }}
                        onError={(e) => { e.currentTarget.style.display = 'none' }}
                    />
                ) : null,

            filter: false,
            suppressHeaderMenuButton: true,
            sortable: false,
            floatingFilter: false,
            autoHeight: true,
        },
        { headerName: 'NAME', field: 'name', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        { headerName: 'DETAIL', field: 'detail', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        // { headerName: 'PATH', field: 'path', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        { headerName: 'LAT', field: 'latitude', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        { headerName: 'LNG', field: 'longitude', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        { headerName: 'PHONE', field: 'phone', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params =>
                params?.data?.status === 'Active'
                    ? <span className='badge text-bg-success'>Active</span>
                    : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'ACTION',
            cellRenderer: params => (
                <div className='d-flex'>
                    <span
                        data-tooltip-id='edit'
                        data-tooltip-content="Gate Update"
                        data-tooltip-place="bottom"
                        onClick={() => editItem(params?.data)}
                    >
                        <FilePenLine className='text-success' size={20} />
                    </span>
                    <span className='ms-2'
                        onClick={() => passwordUpdate(params?.data)}
                        data-tooltip-id='password'
                        data-tooltip-content="Password Update"
                        data-tooltip-place="bottom"
                        type='button'
                    >
                        <LockKeyhole className='text-info' size={20} />
                    </span>
                    {/* <span className='ms-2'
                        data-tooltip-id='delete'
                        data-tooltip-content="Gate Delete"
                        data-tooltip-place="bottom"
                        onClick={() => deleteItem(params?.data?._id)}
                    >
                        <Trash2 className='text-danger' size={20} />
                    </span> */}
                    <Tooltip id='edit' className='bg-success tooltip_msg' />
                    <Tooltip id='delete' className='bg-danger tooltip_msg' />
                    <Tooltip id='password' className='bg-info tooltip_msg' />
                </div>
            ),
            autoHeight: true,
        }
    ];


    useEffect(() => {
        setLoading(true)
        dispatch(gateListTodo({ navigate })).then((res) => list_res(res?.payload))
    }, [bool])
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head d-flex justify-content-between align-items-center mb-3'>
                            <h5>Gate List</h5>
                            <Link to='/add-gate'>   <AddButton label={"Add GATE"} /> </Link>
                        </div>
                        {loading ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={gateList}
                                columnDefs={columnDefs}
                                height={'65vh'}
                            />}
                    </div>
                </div>
            </div>

            <UpdateGatePass show={show} setShow={setShow} userData={userData} />
        </>
    )
}


